import { Select, type SelectProps } from "components/Select/Select"
import { UserDevice } from "interface/device"
import { memo, useMemo } from "react"
import { useDevices } from "services/devices"
import { sortBy } from "utils"

export const SelectDevice = memo(function SelectDevice(
	props: SelectProps<UserDevice["id"]>,
) {
	const { data = [], isFetching } = useDevices()
	const options = useMemo(
		() =>
			data
				.toSorted(sortBy("serialNumber"))
				.map(({ id, serialNumber }) => ({ value: id, label: serialNumber })),
		[data],
	)

	return (
		<Select<UserDevice["id"]>
			{...props}
			aria-label="Device"
			loading={isFetching}
			virtual={false}
			showSearch={{ optionFilterProp: "label" }}
			options={options}
		/>
	)
})
